import Swiper from "swiper";

const landingAdvantages = document.querySelectorAll(".js-landing-advantages-list");

if (window.mobileMedia && landingAdvantages) {
    window.addEventListener("load", () => {
        new Swiper(landingAdvantages, {
            slidesPerView: 1,
            spaceBetween: 17,
            pagination: {
                el: ".js-landing-advantages-list > .js-swiper-pagination",
                dynamicBullets: true,
                dynamicMainBullets: 6,
                clickable: true,
            },
            breakpoints: {
                567: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 28,
                },
            },
        });
    });
}
